import { isDate1GreaterThenDate2 } from '@mng/mng-ts-helpers';
import { GvAngebotData } from '../../gvangebot.model.types';
import { findVn } from './gvperson-model.logic';

/**
 * Wenn der VN eines GV-Angebots eine juristische Person ist und ein FZ-Konto dem Angebot
 * zugeordnet ist wird dieses entfernt
 *
 * Diese Konstellation kommt normalerweise nur bei einem VN-Wechsel vor wenn der VN zuerst
 * eine natürliche Person mit einem FZ-Konto war und dann auf eine juristische Person gewechselt
 * wurde...
 *
 */
export function entferneFzKontoFuerJuristischePersonAlsVn(gvAngebotData: GvAngebotData): GvAngebotData {
  const vn = findVn(gvAngebotData);

  if (vn.stammdaten && vn.stammdaten.juristischePerson && gvAngebotData.fzKonto) {
    return { ...gvAngebotData, fzKonto: null };
  }

  return gvAngebotData;
}

export function hasFzKontoChanged(gvAngebotData: GvAngebotData): boolean {
  if (gvAngebotData.vertragsAenderung) {
    const bestandFzKonto =
      gvAngebotData.bestandFzKonto && gvAngebotData.bestandFzKonto.konto ? gvAngebotData.bestandFzKonto.konto : null;
    const aktuellesFzKonto = gvAngebotData.fzKonto && gvAngebotData.fzKonto.konto ? gvAngebotData.fzKonto.konto : null;
    return aktuellesFzKonto !== bestandFzKonto;
  }
  return false;
}

export function hasVnChanged(gvAngebotData: GvAngebotData): boolean {
  if (gvAngebotData.vertragsAenderung) {
    const bestandVn = gvAngebotData.gvVertragBestandPersonenData?.personen.find((p) => p.personRollen.vn === true);
    if (!bestandVn) {
      return false;
    }
    const aktuellerVn = gvAngebotData.gvPersonenData.personen.find((p) => p.personRollen.vn === true);
    return bestandVn.id !== aktuellerVn.id;
  }
  return false;
}

export function isFzKontoDatumInExpiryRange(fzDatum: string, gvAngebotData: GvAngebotData): boolean {
  if (!fzDatum || !hasFzKontoChanged(gvAngebotData)) {
    // Gültigkeit nur validieren wenn Vertrags-Änderungsdatum === FZ-Konto-Änderungsdatum
    return true;
  }

  let valid = true;

  if (gvAngebotData.fzKonto) {
    const fzGueltigBis = gvAngebotData.fzKonto.giltBis;
    const fzGueltigVon = gvAngebotData.fzKonto.giltVon;
    const isYetValid = fzGueltigVon ? isDate1GreaterThenDate2(fzDatum, fzGueltigVon) : true;
    const isExpired = fzGueltigBis ? isDate1GreaterThenDate2(fzDatum, fzGueltigBis) : false;
    valid = !isExpired && isYetValid;
  }

  return valid;
}
